import React, { useState, useEffect, useRef } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { toast } from 'react-toastify';
import ApiStrategy from '../../Api/ApiStrategy';

const ComboResponsibilityEditor = ({
  value,
  onCommit,
}) => {
  const [responsibility, setResponsibility] = useState(value);
  const [rows, setRows] = useState(null);
  
  const inputRef = useRef();
  const latestResponsibility = useRef(responsibility);

  useEffect(() => {
    setResponsibility(value);
  }, [value]);

  useEffect(() => {
    const fetchEmployees = async () => {
      const res = await ApiStrategy.getStrategyEmployees();
      if (res.status === 200) {
        setRows(res.data);
      } else toast.error(res.message);
    }

    fetchEmployees();
  }, []);

  useEffect(() => {
    latestResponsibility.current = responsibility;
  }, [responsibility]);

  useEffect(() => {
    return () => {
      setTimeout(() => {
        onCommit(latestResponsibility.current);
      }, 0);
    };
  }, []);

  const handleChangeComplete = (event, newVal) => {
    let newRes = '';
    newVal &&
      newVal.forEach((cur, idx) => {
        if (idx > 0) newRes = `${newRes},${cur}`;
        else newRes = cur;
      });
    setResponsibility(newRes);
  };

  let val = responsibility ? responsibility.split(',') : [];
  let options = rows && rows.length > 0 ? rows.map((row) => row.EmployeeName) : [];

  return (
    <Autocomplete
      options={options}
      onChange={handleChangeComplete}
      getOptionLabel={(option) => option}
      value={val}
      style={{
        backgroundColor: '#fff',
        position: 'fixed',
        zIndex: 2,
        minWidth: 200,
      }}
      renderInput={(params) => (
        <TextField 
          {...params} 
          variant="outlined" 
          fullWidth 
          inputRef={inputRef}
        />
      )}
      filterSelectedOptions
      multiple
    />
  );
};

export default ComboResponsibilityEditor;
